import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/js/bootstrap.js";
import "jquery/dist/jquery.slim";
import React, { useEffect, useState } from "react";
import Basic from "../components/Basic";
//import Share from "../components/Share";
import Footer from "../components/Footer";
//import { Link } from "react-router-dom";
import "./Aboutus.css";
//import Accordion from "./Accordion";
import { IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import { FaAngleUp } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
//import LinkIcon from "@mui/icons-material/Link";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AttachmentIcon from "@mui/icons-material/Attachment";

//import { faqs } from "./FAQs";

function Aboutus() {
  const [activeSection, setActiveSection] = useState(null);
  const location = useLocation();
  const [showScrollButton, setShowScrollButton] = useState(false);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = -1;

      if (scrollPosition > scrollThreshold) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
  }, [location]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Basic />
      <div className="containersec">
        <div className="header1">
          <h1>
            <span>WELCOME </span>TO{" "}
            <span style={{ color: "#179f3e" }}>HERBAL CARTEL</span>
          </h1>
          <p>
            Explore nature's remedies within a curated collection of plants
            known for their healing properties. Discover herbal wisdom, benefits
            and usage that enhance your well-being naturally.
          </p>
        </div>
        <div className="Sections1">
          <div className={`section ${activeSection === 1 ? "active" : ""}`}>
            <div className="section-header" onClick={() => toggleSection(1)}>
              <h2>
                Herbal Cartel Vision
                <IconButton
                  size="large"
                  onClick={() => toggleSection(1)}
                  aria-expanded={activeSection === 1}
                  aria-label="expand"
                >
                  <ExpandMoreIcon />
                </IconButton>
              </h2>
            </div>
            {activeSection === 1 && (
              <div className="section-content" style={{ margin: "0 0 0 0" }}>
                Welcome to our{" "}
                <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                  plants heaven!{" "}
                </span>
                Discover the healing wonders of nature as we share insights on
                various medicinal plants. Our dedicated team ensures accuracy
                and authenticity by verifying information before it gets added
                to our website.
                <p>
                  Our primary objective of the website is to educate people
                  about different types of plants, their characteristics, uses,
                  and benefits. This aligns with the goal of promoting
                  environmental awareness and sustainable living practices.
                  <br />
                  By categorizing plants into different groups, the website can
                  highlight the rich biodiversity present in nature. This can
                  encourage people to appreciate and conserve various plant
                  species, contributing to ecosystem health and resilience.
                  Making the website user-friendly and accessible ensures that
                  people from diverse backgrounds and levels of expertise can
                  benefit from the information provided.
                  <br />
                  Explore the richness of herbal remedies and let nature be your
                  guide.
                </p>
                <p>
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    About BNPura lake
                  </span>
                  <br />
                  The BNPura Lake blog is a treasure trove of information about
                  the wonders of nature. Among the many natural wonders
                  discussed on this blog are the medicinal plants found in and
                  around the lake. These plants are known to have therapeutic
                  properties which can be used to help us recover from a variety
                  of ailments.
                  <br />
                  Lake in B. Narayanapura, Mahadevapura, Bangalore development
                  started in year 2017 by BBMP. Residents of near by planted
                  ~280 tree's around lake's walking track (both sides) in year
                  2018 and taking care of them - Watering, Securing with
                  fencing, Re-planting.
                  <br />
                  Blog is developed by Mekala V Reddy who is part of Lake
                  development core team.
                  <br />
                  Team of ~50 members taking care of BNPura Lake (plantation,
                  maintenance) from year 2016/17 onwards, till 2021.
                  <p>
                    Website:{" "}
                    <Link to="https://bnpuralake.blogspot.com/" target="_blank">
                      BNPura Blog
                    </Link>
                  </p>
                  <br />
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="Sections2">
          <div className={`section ${activeSection === 2 ? "active" : ""}`}>
            <div className="section-header" onClick={() => toggleSection(2)}>
              <h2>
                Botanical Timeline
                <IconButton
                  size="large"
                  onClick={() => toggleSection(2)}
                  aria-expanded={activeSection === 2}
                  aria-label="expand"
                >
                  <ExpandMoreIcon />
                </IconButton>
              </h2>
            </div>
            {activeSection === 2 && (
              <div className="section-content" style={{ margin: "0 0 0 0" }}>
                <p>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Introduction:
                  </span>
                  As{" "}
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    plants
                  </span>{" "}
                  are essential to man’s existence, providing food, medicine,
                  and shelter, plant names are mostly as old as the language
                  itself. The plant names are in the form of the name of the
                  genus and listing key characters that would distinguish a
                  species from its relatives. In 1753, Linnaeus' publication of
                  "Species Plantarum" is one of the first books we know.
                  <br />
                  Plant names are in binomial (two name) system way used today.
                </p>
                <p>
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    What makes a plant name?
                  </span>{" "}
                  The scientific name of any plant consists of the name of the
                  genus, followed by the species epithet. The name of the genus
                  is a noun, while the species epithet is usually an adjective.
                  Hybrids that are recognized botanically have a multiplication
                  sign immediately preceding the epithet. Plant names originate
                  from diverse sources. They can be formed from classical
                  languages, personal names, the name of the country where they
                  grow, or from one of their common names. Therefore, they
                  should be referred to as scientific names rather than Latin
                  names. The name of the genus is often derived from mythology
                  or named for an eminent person, not necessarily connected with
                  the plants in question. The species epithet is more likely to
                  have a direct association with the plant it represents.
                </p>
                <p>
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    Scientific names
                  </span>{" "}
                  have the advantage over common names in that they have the
                  same meaning in any part of the world. In addition, they are
                  well-documented, and it is always possible to go back to the
                  original to discover exactly what the author meant, something
                  that is not always possible with common names. Knowing the
                  correct scientific name of a plant allows access to a much
                  wider range of information about it, in sources that may not
                  use common names.
                  <br />
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    Pronunciation
                  </span>{" "}
                  is one of the most controversial aspects of plant names, and
                  although there are strict rules on how to form and spell plant
                  names, there are no rules on how to pronounce them.
                </p>
                <p>
                  Plants are broadly categorised into three types:
                  <ul>
                    <li> Herbs</li>
                    <li> Shrubs</li>
                    <li>Tree's</li>
                  </ul>{" "}
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    Herbs
                  </span>{" "}
                  are a widely distributed and widespread group of plants used
                  in culinary, medicinal, and spiritual purposes. They are
                  defined as small, seed-bearing plants without a woody stem, in
                  which all aerial parts die back to the ground at the end of
                  each growing season.
                  <br />
                  <img src="Herbs.jpg" alt="tress" />
                  <br />
                  <br />
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    {" "}
                    Shrubs
                  </span>{" "}
                  are small to medium-sized perennial woody plants, often
                  referred to as bushes, with multiple stems above ground. They
                  typically grow less than 6 to 10 meters in height.
                  <br />
                  <img src="Shrubs.jpg" alt="tress" />
                  <br />
                  <br />
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    Trees
                  </span>{" "}
                  are perennial plants with an elongated stem or trunk that
                  supports branches and leaves in most species. <br />
                  <img src="Tree.jpg" alt="tress" />
                </p>
                <p>
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    Aranyani –
                  </span>{" "}
                  is a Goddess of the Forests & the animals that dwell within
                  them!!-Rigveda
                  <br />
                  Ayurveda, the science of Life, has served humanity for
                  thousands of years. <br />
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    The word Ayurveda (Science of Life) derives from AYU (Life)
                    & VEDA (Science).
                  </span>{" "}
                  Ayurveda believes that positive health is the basis for
                  attaining FOUR cherished goals of life – Dharma, Artha, Kama,
                  Moksha. Positive health is defined as: Dosha Dhatu Samya
                  (Well-balanced Metabolism) and Prasanna Atma, Indriya, Manah
                  (Happy state of the Soul, Senses & mind), where senses =
                  Gyanendriya’s. Vruksha Ayurvedam – a component of Agnipurana,
                  an ancient Indian scripture, is a dedicated text signifying
                  the importance of Agricultural science. (OR) Ayurvedic
                  treatment to plants.
                </p>
                <p>
                  <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                    The Plant Kingdom is classified into four types:
                  </span>
                  <ol>
                    <li type="number">
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Vanaspati{" "}
                      </span>
                      : These are plants which bear fruits but flowers cannot be
                      seen.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Druma
                      </span>
                      : These are plants in which both fruit and flowers can be
                      seen.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Latha
                      </span>
                      : These are creepers.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Gulma
                      </span>
                      : These include shrubs and herbs.
                    </li>
                  </ol>
                </p>
                <p>
                  <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                    Here are the 12 chapters of Vruksha Ayurvedam:
                  </span>
                  <ol type="number">
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Bhumi Nirupana:
                      </span>{" "}
                      Types of soil and fertility assessment.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Bijopthivithi:
                      </span>
                      Selection and preservation of seeds.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Padapa Vivaksha:
                      </span>{" "}
                      Methods of plant propagation, including seed-based
                      methods.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Roopana Vidana:
                      </span>{" "}
                      Sensory aspects related to plants.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Niscana Vidhi:
                      </span>{" "}
                      Methods and techniques of irrigation.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Poshana Vidhi:
                      </span>{" "}
                      Types and techniques of fertilization.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Drumaraksha:
                      </span>{" "}
                      Saving plants from extreme whethers
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Taru Chikitsha:
                      </span>{" "}
                      Treating plants
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Upavana Kriya:
                      </span>{" "}
                      Practices related to house gardening.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Nivasanna Taru:
                      </span>{" "}
                      Benefits and dangers associated with various plants.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Chitrikarana:
                      </span>{" "}
                      Grafting, cutting, and hybridization techniques.
                    </li>
                    <li>
                      <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                        Taru Mahima:
                      </span>{" "}
                      Importance of trees for humanity.
                    </li>
                  </ol>
                </p>
                Food from plants (annam) is the core life support for humanity,
                rain is the core life support for trees in turn – Gita Ch#4,
                Verse 14.
                <p>
                  Our history explains the value of lakes and trees:
                  <br />
                  <span style={{ color: "#179f3e", fontWeight: "bold" }}>
                    "One pond is equal to 10 wells, one lake is equal to 10
                    ponds, one child is equal to 10 lakes, one tree is equal to
                    10 children" – Mahsya Purana.
                  </span>
                  <br />
                  The process of planting involves preparing pits of about 1
                  ‘hasta’ (~18 inches) or 2 ‘hasta’ in depth and width. These
                  pits should be left to dry, and later filled with cow dung and
                  good mud to plant.
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="Sections3">
          <div className={`section ${activeSection === 3 ? "active" : ""}`}>
            <div className="section-header" onClick={() => toggleSection(3)}>
              <h2>
                Our Team
                <IconButton
                  size="large"
                  onClick={() => toggleSection(3)}
                  aria-expanded={activeSection === 3}
                  aria-label="expand"
                >
                  <ExpandMoreIcon />
                </IconButton>
              </h2>
            </div>
            {activeSection === 3 && (
              <div className="section-content1" style={{ margin: "0 0 0 0" }}>
                <div className="college">
                  <h6 style={{ fontWeight: "bolder", textAlign: "center" }}>
                    <u>Industry Experts</u>
                  </h6>
                  <div className="experts">
                    <div className="row">
                      <div className="col-md-3">
                        <div
                          class="card"
                          style={{
                            borderRadius: "10px",
                          }}
                        >
                          <img
                            class="card-img-top"
                            src="MekalaSir.png"
                            alt="image"
                          />
                          <div class="card-body">
                            <h5 class="card-title">Mekala V Reddy</h5>
                            Development Manager
                            <br />
                            Kyndryl India
                            <br />
                            <Tooltip title="Profile">
                              <AttachmentIcon />
                              <Link
                                to="https://www.linkedin.com/in/mekalavreddy/"
                                target="_blank"
                                style={{ textDecoration: "none" }}
                              >
                                <LinkedInIcon />
                              </Link>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          class="card"
                          style={{
                            borderRadius: "10px",
                          }}
                        >
                          <img
                            class="card-img-top"
                            src="MadhusoodhanSir.jpg"
                            alt="image"
                          />
                          <div class="card-body">
                            <h5 class="card-title">Madhusoodanan K Madhavan</h5>
                            Enterprise Architect
                            <br />
                            Kyndryl India
                            <br />
                            <Tooltip title="Profile">
                              <AttachmentIcon />
                              <Link
                                to="https://www.linkedin.com/in/madhusoodanan/"
                                target="_blank"
                                style={{
                                  textDecoration: "none",
                                }}
                              >
                                <LinkedInIcon />
                              </Link>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          class="card"
                          style={{
                            borderRadius: "10px",
                          }}
                        >
                          <img class="card-img-top" src="" alt="image" />
                          <div class="card-body">
                            <h5 class="card-title">
                              Dr Anjali K Madhusoodanan
                            </h5>
                            BAMS
                            <br />
                            <Tooltip title="Profile">
                              <AttachmentIcon />
                              <Link
                                to="https://www.linkedin.com/in/anjali-k-madhusoodanan-1b0236291/"
                                target="_blank"
                                style={{ textDecoration: "none" }}
                              >
                                <LinkedInIcon />
                              </Link>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <h6 style={{ fontWeight: "bolder", textAlign: "center" }}>
                    <u>Our College</u>
                  </h6>
                  <div className="college1">
                    <img src="Dr Ait.jpg" alt="clglogo" />
                    <h5>
                      <span style={{ fontWeight: "bold" }}>
                        Dr. Ambedkar Institute of Technology{" "}
                      </span>
                    </h5>
                    <p>
                      Accredited by NAAC with “A” Grade
                      <br />
                      Malathalli,Bangalore-560056
                    </p>
                  </div>
                  Dr. Ambedkar Institute of Technology (Dr. AIT) was founded by
                  M.H. Jayaprakash Narayan in 1980. Named after Dr. B.R.
                  Ambedkar, the institute is affiliated to Visvesvaraya
                  Technological University (VTU), Belagavi and is recognized and
                  accredited by AICTE and NBA respectively. The institution is
                  accredited by NAAC with ‘A+’ Grade. The Institution has
                  achieved 163 Rank in National Institutional Ranking Framework
                  (NIRF).
                  <br />
                  <span style={{ fontWeight: "bold" }}>
                    Department of Computer Applications (MCA)
                  </span>
                  <br />
                  The Master of Computer Applications program was accredited by
                  National Board of Accreditation(NBA). This program was
                  established in the year 1999 and is the first PG program
                  started in Dr. Ambedkar Institute of Technology, which is
                  affiliated to Visvesvaraya Technological University, Belagavi
                  and Approved by All India Council for Technical
                  Education(AICTE).
                  <a
                    href="https://drait.edu.in/"
                    target="_blank"
                    style={{ fontWeight: "bolder" }}
                  >
                    Read more
                  </a>
                  <br />
                  <br />
                </div>
                <h6
                  style={{
                    fontWeight: "bolder",
                    fontFamily: "Fredoka, sans-serif",
                    textAlign: "center",
                  }}
                >
                  <u>Our Mentors</u>
                </h6>
                <div className="mentors">
                  <div className="row">
                    <div className="col-md-4">
                      <div
                        class="card"
                        style={{
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          class="card-img-top"
                          src="Bharthimam.jpg"
                          alt="image"
                          style={{
                            borderRadius: "10px",
                          }}
                        />
                        <div class="card-body">
                          <h5 class="card-title">Dr. Bharathi S</h5>
                          Professor <br />
                          MCA Department <br />
                          Dr.Ambedkar Institute Of Technology
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/dr-bharathi-somashekhar-484b3655/"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                fontFamily: "Fredoka, sans-serif",
                              }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div
                        class="card"
                        style={{
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          class="card-img-top"
                          src="Shobhamam.jpg"
                          alt="image"
                          style={{
                            borderRadius: "10px",
                          }}
                        />
                        <div class="card-body">
                          <h5 class="card-title">Mrs. Shobha Rani B R</h5>
                          Associate Professor <br />
                          MCA Department <br />
                          Dr.Ambedkar Institute Of Technology <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/shobha-rani-b-r-00540b33/"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                fontFamily: "Fredoka, sans-serif",
                              }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div className="team">
                  <h6 style={{ fontWeight: "bolder", textAlign: "center" }}>
                    <u>Our Team Members</u>
                  </h6>
                  <div className="row">
                    <div className="col-md-4">
                      <ul type="none">
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>
                            Madhushree B K
                          </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/madhushree-b-k-83801a191/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                        <br />
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}> Harish R</h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/harish-r-a6476a124/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                        <br />
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>
                            Monisha H B <br />
                          </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/monisha-h-b-2519852a8/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-4">
                      <ul type="none">
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>Mayuri M </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/mayuri-m-b47472232"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                        <br />
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>Yashwanth L </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/yash-yashu-0327a928b/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                        <br />
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>
                            Manojkumar Subrahmanya Hegde{" "}
                          </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/manojkumar-hegde-a53161274/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                        <br />
                      </ul>
                    </div>
                    <div className="col-md-4">
                      <ul type="none">
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>Rithesha </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/rithesha-poojary-aa276b229/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                        <br />
                        <li>
                          <h6 style={{ fontWeight: "bolder" }}>
                            Hemanth Kumar R{" "}
                          </h6>
                          Student at Dr.AIT
                          <br />
                          Master of Computer Applications
                          <br />
                          <Tooltip title="Profile">
                            <AttachmentIcon />
                            <Link
                              to="https://www.linkedin.com/in/hemanth-kumar-r-4974321a9/"
                              target="_blank"
                              style={{ textDecoration: "none" }}
                            >
                              <LinkedInIcon />
                            </Link>
                          </Tooltip>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="footer-section">
        <h1>Conclusion</h1>
        <p>
          To put it simply, plants are partners in our life and our health and
          well-being are intrinsically tied to theirs, they are not only objects
          in our surroundings. We guarantee not just our own existence but also
          the flourishing of life on Earth by taking care of and safeguarding
          them. Our collaborative actions will determine how humans and
          environment interact in the future. We can keep going in the direction
          of unsustainable exploitation, which would worsen the state of the
          environment and even bring about the collapse of society.
          Alternatively, we might adopt a more conscientious and regenerative
          strategy, striving to preserve resources, rebuild ecosystems, and
          coexist peacefully with the natural world.
        </p>
        <p
          style={{
            textAlign: "right",
            fontWeight: "bolder",
            marginRight: "15%",
            marginBottom: "x`1%",
          }}
        >
          -Team Herb Cartel
        </p>
      </div>
      <div className="footer-section2">
        <h1>Future Enhancement</h1>
        <p>
          In future we are planning to add more functionalities such as,
          <ul>
            <li>Plant Recognition</li>
            <li>Sharing Plant Information through Social media</li>
            <li>
              Displaying plants that are present in specific lakeside
              environments
            </li>
          </ul>
        </p>
      </div>
      {showScrollButton && (
        <Tooltip title="Scroll up">
          <button className="back-to-top" onClick={scrollToTop}>
            <FaAngleUp />
          </button>
        </Tooltip>
      )}
      <Footer />
    </>
  );
}

export default Aboutus;
